import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import AuthorisedLayout from "./components/AuthorizedLayoutComponent";
import { LocalStorage } from "./helper/appsession";
import LazyLoad from "./LazyLoad";
import { Loader } from "./components/Shared/PageLoader";
import UploadExAComponentQuote from "./components/Quotes/UploadExAComponentQuote";
import TabStorage from "./helper/TabStorage";
import { useLocation } from "react-router-dom";
import ThankYouOptInBidMessage from "./components/ThankYouOptInBidMessage";

const LoginPage = LazyLoad("./components/LoginPage");
const ChangePasswordPage = LazyLoad("./components/ChangePasswordPage");
const DashboardComponent = LazyLoad(
  "./components/Dashboard/DashboardComponent",
);
const CustomerDashboardComponent = LazyLoad(
  "./components/Dashboard/CustomerDashboardComponent",
);
const SupplierDashboardComponent = LazyLoad(
  "./components/Dashboard/SupplierDashboardComponent",
);
const LeadComponent = LazyLoad("./components/Lead/LeadComponent");
const NewLeadComponent = LazyLoad("./components/Lead/NewLeadComponent");
const EditLeadComponent = LazyLoad("./components/Lead/EditLeadComponent");
const ViewLeadComponent = LazyLoad("./components/Lead/ViewLeadComponent");
const QuotesComponent = LazyLoad("./components/Quotes/QuotesComponent");
const NewQuoteComponent = LazyLoad("./components/Quotes/NewQuoteComponent");
const EditQuoteComponent = LazyLoad("./components/Quotes/EditQuoteComponent");
const ViewQuotesComponent = LazyLoad("./components/Quotes/ViewQuotesComponent");
const BidComponent = LazyLoad("./components/Bid/BidComponent");
const NewBidComponent = LazyLoad("./components/Bid/NewBidComponent");
const EditBidComponent = LazyLoad("./components/Bid/EditBidComponent");
const ViewBidComponent = LazyLoad("./components/Bid/ViewBidComponent");
const NewSupplierBidComponent = LazyLoad(
  "./components/NewSupplierBidComponent",
);
const NewCustomerBidComponent = LazyLoad(
  "./components/NewCustomerBidComponent",
);
const ContractsComponent = LazyLoad(
  "./components/Contracts/ContractsComponent",
);
const NewContractsComponent = LazyLoad(
  "./components/Contracts/NewContractsComponent",
);
const NewContractsComponent1 = LazyLoad(
  "./components/Contracts/NewContractsComponent1",
);
const EditContractsComponent = LazyLoad(
  "./components/Contracts/EditContractsComponent",
);
const ContractSupplierView = LazyLoad("./components/ContractSupplierView");
const ContractCustomerView = LazyLoad("./components/ContractCustomerView");
const ViewContractComponent1 = LazyLoad(
  "./components/Contracts/ViewContractComponent1",
);
const ContactsComponent = LazyLoad("./components/Contacts/ContactsComponent");
const NewContactComponent = LazyLoad(
  "./components/Contacts/NewContactComponent",
);
const EditContactComponent = LazyLoad(
  "./components/Contacts/EditContactComponent",
);
const CustomerComponent = LazyLoad("./components/Customer/CustomerComponent");
const NewCustomerComponent = LazyLoad(
  "./components/Customer/NewCustomerComponent",
);
const EditCustomerComponent = LazyLoad(
  "./components/Customer/EditCustomerComponent",
);
const ViewCustomerComponent = LazyLoad(
  "./components/Customer/ViewCustomerComponent",
);
const SupplierComponent = LazyLoad("./components/Supplier/SupplierComponent");
const NewSupplierComponent = LazyLoad(
  "./components/Supplier/NewSupplierComponent",
);
const EditSupplierComponent = LazyLoad(
  "./components/Supplier/EditSupplierComponent",
);
const ViewSupplierComponent = LazyLoad(
  "./components/Supplier/ViewSupplierComponent",
);
const ProjectsComponent = LazyLoad("./components/Projects/ProjectsComponent");
const NewProjectsComponent = LazyLoad(
  "./components/Projects/NewProjectsComponent",
);
const EditProjectsComponent = LazyLoad(
  "./components/Projects/EditProjectsComponent",
);
const UpdateProjectsComponent = LazyLoad(
  "./components/Projects/UpdateProjectsComponent",
);
const ViewProjectsComponent = LazyLoad(
  "./components/Projects/ViewProjectsComponent",
);
const VendorComponent = LazyLoad("./components/Vendor/VendorComponent");
const NewVendorComponent = LazyLoad("./components/Vendor/NewVendorComponent");
const EditVendorComponent = LazyLoad("./components/Vendor/EditVendorComponent");
const ViewVendorComponent = LazyLoad("./components/Vendor/ViewVendorComponent");
const FeatureComponent = LazyLoad("./components/User/FeatureComponent");
const UserComponent = LazyLoad("./components/User/UserComponent");
const NewUserComponent = LazyLoad("./components/User/NewUserComponent");
const EditUserComponent = LazyLoad("./components/User/EditUserComponent");
const ViewUserComponent = LazyLoad("./components/User/ViewUserComponent");
const UserRoleComponent = LazyLoad("./components/User/UserRoleComponent");
const UserTypeComponent = LazyLoad("./components/User/UserTypeComponent");
const RolePermissionComponent = LazyLoad(
  "./components/User/RolePermissionComponent",
);
const UploadExAComponent = LazyLoad("./components/Lead/UploadExAComponent");
const UploadLeadExaCompnent = LazyLoad(
  "./components/Lead/UploadLeadExaCompnent",
);
const UtilityCompanyComponent = LazyLoad(
  "./components/Utility/UtilityCompanyComponent",
);
const AgentComponent = LazyLoad("./components/Agent/AgentComponent");
const NewAgentComponent = LazyLoad("./components/Agent/NewAgentComponent");
const EditAgentComponent = LazyLoad("./components/Agent/EditAgentComponent");
const NewCustomer1Component = LazyLoad("./components/NewCustomer1Component");
const NYAAIntakeFormComponent = LazyLoad(
  "./components/NYAAIntakeFormComponent",
);
const EntityComponent = LazyLoad("./components/Entity/EntityComponent");
const UploadContractExaComponent = LazyLoad(
  "./components/Contracts/UploadContractExaComponent",
);
const ThankYouBidSupplierQuotationMessage = LazyLoad(
  "./components/ThankYouBidSupplierQuotationMessage",
);
const ThankYouSupplierMessage = LazyLoad(
  "./components/ThankYouSupplierMessage",
);
const ThankYouLeadNyaaIntakeForm = LazyLoad(
  "./components/ThankYouLeadNyaaIntakeForm",
);
const ViewContractSupplierComponent = LazyLoad(
  "./components/Contracts/ViewContractSupplierComponent",
);
const ThankYouContractSupplierMessage = LazyLoad(
  "./components/ThankYouContractSupplierMessage",
);
const ViewContractCustomerComponent = LazyLoad(
  "./components/Contracts/ViewContractCustomerComponent",
);
const ThankYouContractCustomerMessage = LazyLoad(
  "./components/ThankYouContractCustomerMessage",
);
const ViewContractFinalSupplierComponent = LazyLoad(
  "./components/Contracts/ViewContractFinalSupplierComponent",
);
const ThankYouExecuteContractMessage = LazyLoad(
  "./components/ThankYouExecuteContractMessage",
);

const ThankYouOptOutBidMessage = LazyLoad(
  "./components/ThankYouOptOutBidMessage",
);

const CommisionComponent = LazyLoad(
  "./components/Commision/CommisionComponent",
);

const UploadQuoteExaComponent = LazyLoad(
  "./components/Quotes/UploadQuoteExaComponent",
);

const CommisionDataComponent = LazyLoad(
  "./components/Commision/CommisionDataComponent",
);

const CommisionUploadedDataComponent = LazyLoad(
  "./components/Commision/CommisionUploadedDataComponent",
);

const CommisionDetailsComponent = LazyLoad(
  "./components/Commision/CommisionDetailsComponent",
);

const ReportConfigurationComponent = LazyLoad(
  "./components/ReportConfigurationComponent",
);
const UploadBulkEntityComponent = LazyLoad(
  "./components/Entity/UploadBulkEntityComponent",
);

const ReportComponent = LazyLoad("./components/Report/ReportComponent");

const App = () => {
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      // debugger;
      const params = new URLSearchParams(location.search);
      const appState = params.get("appState");

      if (appState) {
        try {
          const parsed = JSON.parse(localStorage.getItem("loginData"));

          console.log("Received state from parent tab:", parsed);

          // Example: set to TabStorage
          TabStorage.setSessionItem("authorized", parsed.authorized);
          TabStorage.setSessionItem("currencyicon", parsed.currencyIcon);
          TabStorage.setItem("timezone", parsed.timezone);
          TabStorage.setItem("user", parsed.user);

          localStorage.removeItem("loginData");

          setIsAuthorized(await TabStorage.isAuthorized());
          console.log("Set state to TabStorage:", parsed);
        } catch (err) {
          console.error("Failed to parse state:", err);
        }
      }
    };

    loadData();
  }, [location]);

  useEffect(() => {
    const checkAuth = async () => {
      // debugger;
      setIsAuthorized(await TabStorage.isAuthorized());
    };

    checkAuth();
  }, []);

  console.log("isAuthorized===>", isAuthorized);
  return (
    <>
      {isAuthorized === true ? (
        <AuthorisedLayout>
          <Routes>
            <Route path="/" element={<AuthorizedRouteWrapper />}>
              <Route path="*" element={<RanderDashboard />} />
              <Route path="/" element={<RanderDashboard />} />
              {/* <Route path="/dashboard" element={<RanderDashboard />} /> */}
              <Route path="/home" element={<RanderDashboard />} />
              <Route path="/customer-dashboard" element={<RanderDashboard />} />
              <Route path="/supplier-dashboard" element={<RanderDashboard />} />
              <Route path="/lead" element={<LeadComponent />} />
              <Route path="/new-lead" element={<NewLeadComponent />} />
              <Route path="/edit-lead/:id" element={<EditLeadComponent />} />
              <Route path="/view-lead/:id" element={<ViewLeadComponent />} />
              <Route path="/quotes" element={<QuotesComponent />} />
              <Route path="/new-quote/:id" element={<NewQuoteComponent />} />
              <Route path="/new-quote" element={<NewQuoteComponent />} />
              <Route path="/edit-quote/:id" element={<EditQuoteComponent />} />
              <Route path="/view-quote/:id" element={<ViewQuotesComponent />} />
              <Route path="/bid" element={<BidComponent />} />
              <Route path="/new-bid/:id" element={<NewBidComponent />} />
              <Route path="/edit-bid/:id" element={<EditBidComponent />} />
              <Route path="/view-bid/:id" element={<ViewBidComponent />} />
              <Route path="/contracts" element={<ContractsComponent />} />
              <Route
                path="/new-contract/:id"
                element={<NewContractsComponent />}
              />
              <Route
                path="/new-contract1"
                element={<NewContractsComponent1 />}
              />
              <Route
                path="/edit-contract"
                element={<EditContractsComponent />}
              />
              <Route
                path="/view-contract1"
                element={<ViewContractComponent1 />}
              />
              <Route path="/contacts" element={<ContactsComponent />} />
              <Route path="/new-contact" element={<NewContactComponent />} />
              <Route path="/edit-contact" element={<EditContactComponent />} />
              <Route path="/customer" element={<CustomerComponent />} />
              <Route path="/new-customer" element={<NewCustomerComponent />} />
              <Route
                path="/new-customer/:id"
                element={<NewCustomerComponent />}
              />
              <Route
                path="/edit-customer/:id"
                element={<EditCustomerComponent />}
              />
              <Route
                path="/view-customer/:id"
                element={<ViewCustomerComponent />}
              />
              <Route path="/supplier" element={<SupplierComponent />} />
              <Route path="/new-supplier" element={<NewSupplierComponent />} />
              <Route
                path="/edit-supplier/:id"
                element={<EditSupplierComponent />}
              />
              <Route
                path="/view-supplier/:id"
                element={<ViewSupplierComponent />}
              />
              <Route path="/projects" element={<ProjectsComponent />} />
              <Route path="/new-project" element={<NewProjectsComponent />} />
              <Route path="/edit-project" element={<EditProjectsComponent />} />
              <Route
                path="/edit-project/:id"
                element={<NewProjectsComponent />}
              />
              <Route
                path="/update-project"
                element={<UpdateProjectsComponent />}
              />
              <Route
                path="/view-project/:id"
                element={<ViewProjectsComponent />}
              />
              <Route path="/vendor" element={<VendorComponent />} />
              <Route path="/new-vendor" element={<NewVendorComponent />} />
              <Route
                path="/edit-vendor/:id"
                element={<EditVendorComponent />}
              />
              <Route
                path="/view-vendor/:id"
                element={<ViewVendorComponent />}
              />
              <Route path="/feature" element={<FeatureComponent />} />
              <Route path="/user" element={<UserComponent />} />
              <Route path="/new-user" element={<NewUserComponent />} />
              <Route path="/edit-user" element={<EditUserComponent />} />
              <Route path="/view-user" element={<ViewUserComponent />} />
              <Route path="/userrole" element={<UserRoleComponent />} />
              <Route path="/usertype" element={<UserTypeComponent />} />
              <Route
                path="/role-permission"
                element={<RolePermissionComponent />}
              />
              <Route path="/upload-exa/:id" element={<UploadExAComponent />} />
              <Route
                path="/upload-lead-exa"
                element={<UploadLeadExaCompnent />}
              />
              <Route
                path="/upload-exa-quote/:id"
                element={<UploadExAComponentQuote />}
              />
              <Route
                path="/utility-company"
                element={<UtilityCompanyComponent />}
              />
              <Route path="/ap-recipient" element={<AgentComponent />} />
              <Route path="/new-ap-recipient" element={<NewAgentComponent />} />
              <Route
                path="/edit-ap-recipient/:id"
                element={<EditAgentComponent />}
              />
              <Route path="/entity-info" element={<EntityComponent />} />
              <Route
                path="/upload-contract-exa"
                element={<UploadContractExaComponent />}
              />
              <Route path="/commision" element={<CommisionComponent />} />
              <Route
                path="/upload-quote-exa"
                element={<UploadQuoteExaComponent />}
              />
              <Route
                path="/commision-data"
                element={<CommisionDataComponent />}
              />
              <Route
                path="/commision-uploaded-data"
                element={<CommisionUploadedDataComponent />}
              />
              <Route
                path="/commision-details"
                element={<CommisionDetailsComponent />}
              />
              <Route
                path="/report-configuration"
                element={<ReportConfigurationComponent />}
              />
              <Route path="/report" element={<ReportComponent />} />
              <Route
                path="/upload-entity"
                element={<UploadBulkEntityComponent />}
              />
            </Route>
          </Routes>
        </AuthorisedLayout>
      ) : (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="*" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route
              path="/new-supplier-bid"
              element={<NewSupplierBidComponent />}
            />
            <Route
              path="/new-customer-bid/:id"
              element={<NewCustomerBidComponent />}
            />
            <Route
              path="/contract-supplier-view"
              element={<ContractSupplierView />}
            />
            <Route
              path="/contract-customer-view"
              element={<ContractCustomerView />}
            />
            <Route path="/new-cust" element={<NewCustomer1Component />} />
            <Route path="/nyaa-intake" element={<NYAAIntakeFormComponent />} />
            <Route
              path="/thank-you-submit-bid-supplier"
              element={<ThankYouBidSupplierQuotationMessage />}
            />
            <Route
              path="/thank-you-add-supplier"
              element={<ThankYouSupplierMessage />}
            />
            <Route
              path="/thank-you-add-nyaa-intake"
              element={<ThankYouLeadNyaaIntakeForm />}
            />
            <Route
              path="/view-supplier-contract"
              element={<ViewContractSupplierComponent />}
            />
            <Route
              path="/view-customer-contract"
              element={<ViewContractCustomerComponent />}
            />
            <Route
              path="/view-final-supplier-contract"
              element={<ViewContractFinalSupplierComponent />}
            />
            <Route
              path="/thank-you-contract-supplier"
              element={<ThankYouContractSupplierMessage />}
            />
            <Route
              path="/thank-you-contract-customer"
              element={<ThankYouContractCustomerMessage />}
            />
            <Route
              path="/thank-you-execute-contract"
              element={<ThankYouExecuteContractMessage />}
            />
            <Route
              path="/thank-you-opt-out-bid"
              element={<ThankYouOptOutBidMessage />}
            />
            <Route
              path="/thank-you-opt-in-bid"
              element={<ThankYouOptInBidMessage />}
            />
          </Routes>
        </Suspense>
      )}
    </>
  );
};
export default App;

function AuthorizedRouteWrapper() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </>
  );
}
function RanderDashboard() {
  // let user = JSON.parse(LocalStorage.getItem("user"))
  // debugger
  let user = TabStorage.getItem("user");
  let dashboard = <DashboardComponent />;
  switch (user?.userTypeId) {
    case 2001:
      dashboard = <CustomerDashboardComponent />;
      break;
    case 3001:
      dashboard = <SupplierDashboardComponent />;
      break;
    default:
      break;
  }
  return dashboard;
}
